"use client";

import { useMemo } from "react";
import { useProject } from "@/features/project/ProjectContext";
import type { MediaContext } from "./mediaUrl";

/**
 * The two identifiers every media URL needs.
 *
 * Both come from the server-seeded project, so this never suspends or changes:
 * the *domain* is how the media routes address a project, and the *id* is the
 * prefix on every stored path. They are different on purpose — a tenant can move
 * to a new domain without its stored media becoming unreachable.
 */
export function useMediaContext(): MediaContext {
  const project = useProject();

  return useMemo(
    () => ({ domain: project?.domain, projectSegment: project?.id }),
    [project?.domain, project?.id]
  );
}
